module.exports = __webpack_public_path__ + "img/hot-qa.03b562dd.png";